import React from "react";
import LocalGroceryStoreOutlinedIcon from "@mui/icons-material/LocalGroceryStoreOutlined";
import imgOne from "../img/products/f1.jpg";
import imgTwo from "../img/products/f2.jpg";
import imgThree from "../img/products/f3.jpg";
import imgFour from "../img/products/f4.jpg";
import imgFive from "../img/products/f5.jpg";
import imgSix from "../img/products/f6.jpg";
import imgSeven from "../img/products/f7.jpg";
import imgEight from "../img/products/f8.jpg";
function Products() {
  return (
    <div className="products">
      <div className="products-heading">
        <h2>Featured Products</h2>
        <span>Summer Collection New Modern Design</span>
      </div>
      <div className="container">
        <div className="card">
          <img src={imgOne} alt="f1" />
          <div className="card-body">
            <span>Adidas</span>
            <h5>Cartoon Astronout T-Shirts</h5>
            <div className="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
            <div className="card-footer">
              <span>
                <i class="fa-duotone fa-dollar-sign"></i>78
              </span>
              <LocalGroceryStoreOutlinedIcon className="shopping-icon" />
            </div>
          </div>
        </div>
        <div className="card">
          <img src={imgTwo} alt="f2" />
          <div className="card-body">
            <span>Adidas</span>
            <h5>Cartoon Astronout T-Shirts</h5>
            <div className="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
            <div className="card-footer">
              <span>
                <i class="fa-duotone fa-dollar-sign"></i>78
              </span>
              <LocalGroceryStoreOutlinedIcon className="shopping-icon" />
            </div>
          </div>
        </div>
        <div className="card">
          <img src={imgThree} alt="f2" />
          <div className="card-body">
            <span>Adidas</span>
            <h5>Cartoon Astronout T-Shirts</h5>
            <div className="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
            <div className="card-footer">
              <span>
                <i class="fa-duotone fa-dollar-sign"></i>78
              </span>
              <LocalGroceryStoreOutlinedIcon className="shopping-icon" />
            </div>
          </div>
        </div>
        <div className="card">
          <img src={imgFour} alt="f4" />
          <div className="card-body">
            <span>Adidas</span>
            <h5>Cartoon Astronout T-Shirts</h5>
            <div className="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
            <div className="card-footer">
              <span>
                <i class="fa-duotone fa-dollar-sign"></i>78
              </span>
              <LocalGroceryStoreOutlinedIcon className="shopping-icon" />
            </div>
          </div>
        </div>
        <div className="card">
          <img src={imgFive} alt="f5" />
          <div className="card-body">
            <span>Adidas</span>
            <h5>Cartoon Astronout T-Shirts</h5>
            <div className="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
            <div className="card-footer">
              <span>
                <i class="fa-duotone fa-dollar-sign"></i>78
              </span>
              <LocalGroceryStoreOutlinedIcon className="shopping-icon" />
            </div>
          </div>
        </div>
        <div className="card">
          <img src={imgSix} alt="f6" />
          <div className="card-body">
            <span>Adidas</span>
            <h5>Cartoon Astronout T-Shirts</h5>
            <div className="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
            <div className="card-footer">
              <span>
                <i class="fa-duotone fa-dollar-sign"></i>78
              </span>
              <LocalGroceryStoreOutlinedIcon className="shopping-icon" />
            </div>
          </div>
        </div>
        <div className="card">
          <img src={imgSeven} alt="f7" />
          <div className="card-body">
            <span>Adidas</span>
            <h5>Cartoon Astronout T-Shirts</h5>
            <div className="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
            <div className="card-footer">
              <span>
                <i class="fa-duotone fa-dollar-sign"></i>78
              </span>
              <LocalGroceryStoreOutlinedIcon className="shopping-icon" />
            </div>
          </div>
        </div>
        <div className="card">
          <img src={imgEight} alt="f8" />
          <div className="card-body">
            <span>Adidas</span>
            <h5>Cartoon Astronout T-Shirts</h5>
            <div className="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
            <div className="card-footer">
              <span>
                <i class="fa-duotone fa-dollar-sign"></i>78
              </span>
              <LocalGroceryStoreOutlinedIcon className="shopping-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Products;
